import React, { Component, Fragment } from "react";

import "./ProductImage.css";

import ImageList from "./ImageList/ImageList"
 
const UP = -1
const DOWN = 1

class ProductImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageList: [
        // {'id': 1, 'name': 'orange', 'size': '100 KB', 'primery': true},
        // {'id': 2, 'name': 'lemon','size' : '200 KB', 'primery': false},
        // {'id': 3, 'name': 'strawberry', 'size': '300 KB', 'primery': false},
        // {'id': 4, 'name': 'apple', 'size' : '400 KB', 'primery': false},
      ],          

      
    };

  }


  handleMove = (id, direction) => {
    const {imageList} = this.state

    const position = imageList.findIndex((i) => i.id === id)
    if (position < 0) {
      throw new Error("Given item not found.")
    } else if (direction === UP && position === 1 || direction === DOWN && position === imageList.length - 1) {
      return // canot move outside of array
    }

    const item = imageList[position] // save item for later
    const newItems = imageList.filter((i) => i.id !== id) // remove item from array
    newItems.splice(position + direction, 0, item)

    const tempId = newItems[position].id;
    newItems[position].id = newItems[position + direction].id;
    newItems[position + direction].id = tempId;

    this.setState({imageList: newItems},()=>{
      this.props.addProductImageHandler(newItems);
    });
  }

  handleFlag = (id) => {
    const {imageList} = this.state

    const position = imageList.findIndex((i) => i.id === id)
    if (position < 0) {
        throw new Error("Given item not found.")
    }

    if(imageList[position].primery === true){
        imageList[position].primery = false
        this.setState({imageList: imageList}, () => {
            this.props.addProductImageHandler(imageList);
        })
    } else {
        if(position===0){
            imageList[position].primery = true
            this.setState({imageList: imageList}, () => {
            this.props.addProductImageHandler(imageList);
        })  
        } else{
            const item = imageList[position] // save item for later
            item.primery=true
            const newItems = imageList.filter((i) => i.id !== id) // remove item from array
            newItems[0].primery=false
            newItems.splice(0, 0, item)

            for (let index = 0; index < newItems.length; index++) {
              newItems[index].id = index+1;
            }  

            this.setState({imageList: newItems},()=>{
              this.props.addProductImageHandler(newItems);
            });
        }        
    }
  }


  handleRemove = (id) => {
    const {imageList} = this.state
    // console.log(id);
    const position = imageList.findIndex((i) => i.id === id)
    // console.log(position);
    if (position < 0) {
      throw new Error("Given item not found.")
    }

    const item = imageList[position] // save item for later
    const newItems = imageList.filter((i) => i.id !== id) // remove item from array

    for (let index = position; index < newItems.length; index++) {
      newItems[index].id = newItems[index].id-1;
    }

    // console.log(newItems);
    this.setState({imageList: newItems},()=>{
      this.props.addProductImageHandler(newItems);
    });
  }

  handleDragStart = (event, id) => {
    const {imageList} = this.state
    const position = imageList.findIndex((i) => i.id === id)
    this.draggedItem = imageList[position];

    event.dataTransfer.setDragImage(event.target.parentNode.parentNode.parentNode, 20, 20);
    event.dataTransfer.effectAllowed = "move";
    event.dataTransfer.setData("text/html", event.target.parentNode.parentNode.parentNode);
  };

  handleDragOver = id => {
    const {imageList} = this.state
    const position = imageList.findIndex((i) => i.id === id)
    const hoveredItem = imageList[position];
    // console.log(hoveredItem);

    if (this.draggedItem === hoveredItem) {
      return;
    } else if (hoveredItem === imageList[0] && imageList[0].primery==true) {
      return;  
    }

    const filteredItems = imageList.filter(item => item !== this.draggedItem);

    filteredItems.splice(position, 0, this.draggedItem);

    this.setState({ imageList: filteredItems },()=>{
      this.props.addProductImageHandler(filteredItems);
    });
  };

  handleDragEnd = () => {
    this.draggedIdx = null;
  };

  handleImageChange = (event) =>{
    var filesize;
    if(parseInt(event.target.files[0].size)<1048576){
        filesize = event.target.files[0].size/ (1024);
        filesize = filesize.toFixed(2).toString()+" KB";
    }else{
        filesize = event.target.files[0].size/ (1024*1024);
        filesize = filesize.toFixed(2).toString()+" MB";
    }


    const formData = new FormData();

    formData.append("image", event.target.files[0]);

    const length = this.state.imageList.length;
    let newImageList = [...this.state.imageList];
    newImageList.push({'id': length+1, 'imageId': 1, 'value': event.target.files[0], 'image': URL.createObjectURL(event.target.files[0]), 'name': event.target.files[0].name, 'size': filesize, 'primery': false});
      
    
    fetch(process.env.REACT_APP_BACKEND_URL + "/post-product-image", {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + this.props.token,
      },
      body: formData,
    })
    .then((res) => res.json())
    .then((fileResData) => {
      
      const Index = newImageList.findIndex(
        (p) => p.id === length+1
      );

      newImageList[Index].imageId= fileResData.id;
      
      this.setState({ imageList: newImageList },()=>{
        this.props.addProductImageHandler(newImageList);
      });
    })
    .catch((err) => {
      console.log(err);
      this.setState({
        error: err,
      });
    });



      
  };



  ////////////////////////////////////////////////////////////////////////////////////////

//   componentDidUpdate(previousProps, previousState) {
//     if (previousProps.categoryData !== this.props.categoryData) {
//       this.fetchProductAttributes(this.props.categoryData.code);
//       this.countProductAttributes(this.props.categoryData.code);
//     }
//   }



//   countProductAttributes = (code) => {
//     const graphqlQuery = {
//       query: `
//             query FetchProductAttributes($categoryCode: Int) {
//               countProductAttributes(categoryCode: $categoryCode){
//                 count
//               }
//             }
//           `,
//       variables: {
//         categoryCode: code,
//       },
//     };
//     fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
//       method: "POST",
//       headers: {
//         Authorization: "Bearer " + this.props.token,
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(graphqlQuery),
//     })
//       .then((res) => {
//         return res.json();
//       })
//       .then((resData) => {   
//         if (resData.errors) {
//           throw new Error("مشکل در دریافت ویژگی‌ها!");
//         }
//         this.setState({
//           productAttributesCount: resData.data.countProductAttributes.count,
//         });
//       })
//       .catch(this.catchError);
//   };

  

//   catchError = (error) => {
//     this.props.errorCatcher.bind(this, error);
//   };

  render() {
    return (
      <Fragment>
        <div className="mn-card__body mn-card__body--content marketplace-redesign" id="stepImagesContent">
            <form id="stepImagesForm" noValidate="novalidate" onSubmit={e => { e.preventDefault(); }}>
                <div id="imagesSelfServiceContainer" className="mn-grid__row mn-grid__row--gap-lg">
                    <div className="mn-grid__col">
                        <fieldset className="mn-content-upload">
                            <legend className="mn-content-upload__title">تصویر اصلی و گالری تصاویر</legend>
                            <div>
                                <label className="mn-content-upload__trigger" id="uploadGalleryContainer">
                                    <div uk-form-custom="" className="uk-form-custom">
                                        <input type="file" multiple="" className="hidden" onChange={ (event) => this.handleImageChange(event) }/>
                                    </div>
                                    <span className="mn-content-upload__ui-btn">بارگذاری تصاویر</span>
                                    <ul className="mn-content-upload__list mn-content-upload__list--tooltips">
                                        <li className="mn-content-upload__list-item mn-content-upload__list-item--tooltips">ابعاد تصویر بایستی در بازه ۶۰۰x۶۰۰ تا ۲۵۰۰x۲۵۰۰ و حجم آن باید کمتر از ۶ مگابایت باشد.</li>
                                        <li className="mn-content-upload__list-item mn-content-upload__list-item--tooltips">کالا باید ۸۵٪ کل تصویر را در برگیرد و پس زمینه تصویر اصلی باید کاملاً سفید باشد.</li>
                                        <li className="mn-content-upload__list-item mn-content-upload__list-item--tooltips">تصویر باید فقط کالایی که قصد فروش آن را دارید نمایش دهد و بدون هیچ لوگو، نوشته و یا واترمارکی باشد..</li>
                                        <li className="mn-content-upload__list-item mn-content-upload__list-item--tooltips">تصویر شما باید مربعی باشد یا ابعاد یک در یک داشته باشد</li>
                                        <li className="mn-content-upload__list-item mn-content-upload__list-item--tooltips">فرمت تصاویر بایستی JPG باشد</li>
                                        <li className="mn-content-upload__list-item mn-content-upload__list-item--tooltips">امکان آپلود چندین تصویر به صورت همزمان وجود دارد</li>
                                        <li className="mn-content-upload__list-item mn-content-upload__list-item--tooltips">امکان تغییر ترتیب نمایش تصاویر با کشیدن و رها کردن وجود دارد</li>
                                    </ul>
                                </label>
                                {/* <div id="imagesLoadingSection" className="mn-content-upload__uploads loading js-uploading-section" style={{  }}>
                                    <h3 className="product-form__section-title product-form__section-title--gap">
                                            تصاویر درحال بارگذاری
                                        </h3>
                                    <ul id="imagesUploadList" className="mn-content-upload__gallery-list">
                                        <li className="mn-content-upload__gallery-row js-uploads-row has-error" id="uploadedFileId_2">
                                            <input type="hidden" className="js-image-id-input"/>
                                            <div className="mn-content-upload__img-container">
                                                <img src="" alt="" className="mn-content-upload__img js-upload-thumb"/>
                                                <div className="mn-content-upload__img-loader">
                                                    <div className="progress__wrapper"> <span className="progress"></span>
                                                    </div>
                                                </div>
                                                <div className="mn-content-upload__img-error"></div>
                                            </div>
                                            <div className="mn-content-upload__mid-container">
                                                <div className="mn-content-upload__mid-container mn-content-upload__mid-container--top">
                                                    <div className="mn-content-upload__desc">
                                                        <div className="mn-content-upload__desmn--top">
                                                            <div className="right">
                                                                <div className="mn-content-upload__name js-upload-name">persol-3050-v.jpg</div>
                                                                <div className="mn-content-upload__size js-upload-size">118 KB</div>
                                                            </div>
                                                            <div className="mn-content-upload__select"></div>
                                                        </div>
                                                    </div>
                                                    <ul className="mn-content-upload__list mn-content-upload__list--errors js-upload-error-list">
                                                        <li>نسبت طول و عرض تصویر 1 به 1 نیست</li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className="mn-content-upload__controls">
                                                <button type="button" className="mn-content-upload__btn mn-content-upload__btn--flag js-flag-primary js-tooltip" data-tooltip="از این پرچم برای انتخاب تصویر اصلی استفاده کنید"></button>
                                                <button type="button" className="mn-content-upload__btn mn-content-upload__btn--cancel js-cancel-upload"></button> 
                                                <button type="button" className="mn-content-upload__btn mn-content-upload__btn--remove js-remove-upload"></button>
                                                <button type="button" className="mn-content-upload__btn mn-content-upload__btn--undo js-undo-remove"></button>
                                                <div className="mn-content-upload__drag-handler mn-content-upload__drag-handler--outer"> 
                                                    <span className="mn-content-upload__drag-handler mn-content-upload__drag-handler--up js-sort-up"></span>
                                                    <span className="mn-content-upload__drag-handler mn-content-upload__drag-handler--bg"></span>
                                                    <span className="mn-content-upload__drag-handler mn-content-upload__drag-handler--down js-sort-down"></span>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div> */}
                                <div className="mn-content-upload__error-container hidden" id="ajaxErrorImages">
                                    <div className="mn-content-upload__error">
                                        <div className="hidden" id="imageErrorsContainer"></div>
                                        <div className="hidden mn-content-upload__error-msg" id="mainImageErrorContainer"> می‌توانید با استفاده از کلید<i></i> تصویر مورد نظرتان را به عنوان تصویر اصلی کالا انتخاب کنید.</div>
                                    </div>
                                </div>
                                {this.state.imageList.length!==0 &&
                                <div id="imagesSection" className="mn-content-upload__uploads js-uploaded-section">
                                    <h3 className="product-form__section-title product-form__section-title--gap">
                                        تصاویر بارگذاری شده
                                    </h3>
                                    {/* ///////////////// */}
                                    <input type="hidden" name="images[main_image]" id="mainImageContainer" value="1YGiO"/>  
                                    <input type="hidden" name="images[order]" id="imagesOrderContainer"/>
                                    {/* ///////////////// */}
                                    <ImageList  
                                      imageList={this.state.imageList} 
                                      onMove={this.handleMove} 
                                      onRemove={this.handleRemove} 
                                      onFlag={this.handleFlag}
                                      onDragOver={this.handleDragOver}
                                      onDragStart={this.handleDragStart}
                                      onDragEnd={this.handleDragEnd}
                                    />
                                </div>
                                }
                            </div>
                        </fieldset>
                    </div>
                </div>
            </form> 
            <span></span>
        </div>              
      </Fragment>
    );
  }
}

export default ProductImage;


{/* <div id="imagesLoadingSection" className="mn-content-upload__uploads loading js-uploading-section hidden">
                                    <h3 className="product-form__section-title product-form__section-title--gap">
                                            تصاویر درحال بارگذاری
                                        </h3>
                                    <ul id="imagesUploadList" className="mn-content-upload__gallery-list"></ul>
                                </div>
                                <div className="mn-content-upload__error-container hidden" id="ajaxErrorImages">
                                    <div className="mn-content-upload__error">
                                        <div className="hidden" id="imageErrorsContainer"></div>
                                        <div className="hidden mn-content-upload__error-msg" id="mainImageErrorContainer">می‌توانید با استفاده از کلید<i></i> تصویر مورد نظرتان را به عنوان تصویر اصلی کالا انتخاب کنید.</div>
                                    </div>
                                </div>
                                <div id="imagesSection" className="mn-content-upload__uploads js-uploaded-section hidden">
                                    <h3 className="product-form__section-title product-form__section-title--gap">
                                            تصاویر بارگذاری شده
                                        </h3>
                                    <input type="hidden" name="images[main_image]" id="mainImageContainer" value=""/>
                                    <input type="hidden" name="images[order]" id="imagesOrderContainer"/>
                                    <ul id="imagesContainer" className="mn-content-upload__gallery-list js-uploaded-list js-sortable-list uk-sortable uk-sortable-empty"></ul>
                                    <div type="button" className="mn-content-upload__show-more hidden">بیشتر</div>
                                </div> */}

